export default "__VITE_ASSET__fGUSbx1h__"